var GameGuideDoubleSpeedBubble = xClass("GameGuideDoubleSpeedBubble", cc.Node)

GameGuideDoubleSpeedBubble.show = function () {
    return GameGuideDoubleSpeedBubble.create()
}
GameGuideDoubleSpeedBubble.prototype.ctor = function () {
    var self = this
    cc.log(self)
    cc.Node.prototype.ctor.call(self)
    
    self.init()
}
GameGuideDoubleSpeedBubble.prototype.init = function () {
    var self = this
    function success() {
        var node = cc.CSLoader.createNode("cocos/double_guidance_bubblebox.csb")
        self.addChild(node, 1000)
        var targetScale = node.getScale()
        node.setScale(0)
        var s = node.getContentSize()
        var pos = node.getAnchorPoint()
        var vSize = cc.Director.getInstance().getVisibleSize()
        var pauseBtn = self.getParent().pauseBtn
        var targetPos = cc.p(pauseBtn.x+50, pauseBtn.y-90)
        node.setPosition(cc.p(pauseBtn.x+50, pauseBtn.y-90))
        var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(node.getPosition())), 1.05)
        var a1 = cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint)))
        var a2 = cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))
        var a3 = cc.callFunc(()=>{
            var clear = function(){
                var a4 = cc.scaleTo(0.25, 0)
                var a5 = cc.callFunc(()=>{
                    self.removeFromParent()
                })
                node.runAction(cc.Sequence.create(a4, a5))
            }
            setTimeout(clear, 5000)
        })
        node.runAction(cc.Sequence.create(a1, a2, a3))
    }
    preloadWithLoading(["packed/GameGuideDoubleSpeedBubbleRes.pack"], success, function () {
        Toast.make(getText("error.tip.load_res_error"))
    }, function () {
        Toast.make(getText("error.tip.load_canceled"))
    })
}
// GameGuideDoubleSpeedBubble.prototype.init = function () {
//     var self = this
//     BasePanel.prototype.init.call(self)

//     self.runAction(cc.sequence(cc.delayTime(5), cc.callFunc()))
// }
// GameGuideDoubleSpeedBubble.prototype.popup = function () {
//     var self = this
//     // body
//     var targetScale = self.getScale()
//     self.setScale(0)
//     PopoutManager.getInstance().addWithBgFadeIn(self, true, false)
//     var s = self.getContentSize()
//     var pos = self.getAnchorPoint()
//     var vSize = cc.Director.getInstance().getVisibleSize()
//     // var targetPos = cc.p((vSize.width - s.width) * 0.5 + s.width * pos.x + s.width*0.5, (vSize.height + s.height) * 0.5 + s.height * pos.y - s.height*0.5)
//     var targetPos = cc.p(220, vSize.height-130)
//     // self.setPosition(cc.p(vSize.width / 2, vSize.height / 2 - 80))
//     self.setPosition(cc.p(220, vSize.height-130))
//     var midPoint = cc.pMul(cc.pSub(targetPos, cc.p(self.getPosition())), 1.05)
//     self.runAction(cc.Sequence.create(cc.EaseSineOut.create(cc.Spawn.create(cc.ScaleTo.create(0.25, 1.05 * targetScale), cc.MoveBy.create(0.25, midPoint))), cc.EaseSineIn.create(cc.Spawn.create(cc.ScaleTo.create(0.25, targetScale), cc.MoveTo.create(0.25, targetPos)))))
//     return self
// }
// GameGuideDoubleSpeedBubble.prototype.fitResolution = function () {
//     var self = this
//     // body
// }
// GameGuideDoubleSpeedBubble.prototype.onCleanup = function () {
//     ResManager.release(["packed/GameGuideDoubleSpeedBubbleRes.pack"])
// }

module.exports = GameGuideDoubleSpeedBubble